import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=68eb71ca&scoped=true&"
import script from "./LayoutBasic.vue?vue&type=script&lang=js&"
export * from "./LayoutBasic.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=68eb71ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb71ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68eb71ca')) {
      api.createRecord('68eb71ca', component.options)
    } else {
      api.reload('68eb71ca', component.options)
    }
    module.hot.accept("./LayoutBasic.vue?vue&type=template&id=68eb71ca&scoped=true&", function () {
      api.rerender('68eb71ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutBasic.vue"
export default component.exports